<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>正在促销</el-breadcrumb-item>
    </el-breadcrumb>
    <promotion-list :category="1"></promotion-list>
  </div>
</template>

<script>
import PromotionList from './list'
export default {
  components: { PromotionList },
}
</script>